import React, { useEffect, useState } from "react";
import { getAllGroups } from "../utils/groupApi";
import { useNavigate } from "react-router-dom";

export default function Groups() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      const res = await getAllGroups();

      // 🔥 Only show root groups
      const rootGroups = res.data.filter(g => !g.parentId);

      setGroups(rootGroups);
      setLoading(false);
    } catch (err) {
      console.error("Failed to load groups", err);
      setLoading(false);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-xl font-bold mb-4">📚 Root Playlists</h2>

      <button
        className="mb-4 bg-black text-white px-4 py-2 rounded"
        onClick={() => navigate("/groups/create")}
      >
        ➕ Create Group
      </button>

      {groups.length === 0 && (
        <p className="text-gray-500">No root playlists found</p>
      )}

      {groups.map(g => (
        <div
          key={g._id}
          className="border p-4 mb-3 cursor-pointer hover:bg-gray-100 rounded"
          onClick={() => navigate(`/groups/${g._id}`)}
        >
          <b>{g.name}</b>
          <p className="text-gray-600">{g.description}</p>
        </div>
      ))}
    </div>
  );
}